module.exports = __webpack_public_path__ + "img/icon1.79cee5fa.png";